module.exports = "/static/media/experts.5e51517f.svg";